import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const scrollPositions = new Map();

const SmartScroll = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const scrollContainer = document.querySelector('.page-wrapper');

    // Save previous scroll position
    if (prevPathRef.current && scrollContainer) {
      scrollPositions.set(prevPathRef.current, scrollContainer.scrollTop);
    }

    // Wait for render before scroll adjustment
    requestAnimationFrame(() => {
      if (!scrollContainer) return;

      if (navigationType === 'POP') {
        const savedScroll = scrollPositions.get(pathname);
        if (savedScroll !== undefined) {
          scrollContainer.scrollTo({ top: savedScroll, behavior: 'auto' });
        }
      } else if (navigationType === 'PUSH') {
        scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    // Update previous path after effect runs
    prevPathRef.current = pathname;
  }, [pathname, navigationType]);

  return null;
};

export default SmartScroll;